import { useState } from "react";
import { Chip, Tooltip } from "@mui/material";
import { colors, fontFamilyMono, radius } from "../data/tokens";
import { truncateString } from "../ra-components/users/UserUtils";

// ------------------------------------------------------------------
// Chip padrão para exibir IDs técnicos (Iugu etc.) em tabelas.
// Não parece botão de navegação: parece etiqueta — e o clique tem
// ação real: copia o ID completo (com feedback "Copiado!").
// ------------------------------------------------------------------

export function IdChip({ value, length = 13 }: { value: string; length?: number }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // clipboard indisponível (http/permissão): sem feedback, sem quebra
    }
  };

  return (
    <Tooltip title={copied ? "Copiado!" : `${value} — clique para copiar`}>
      <Chip
        label={truncateString(value, length)}
        size="small"
        onClick={handleCopy}
        sx={{
          fontFamily: fontFamilyMono,
          fontSize: "0.72rem",
          backgroundColor: colors.bgContent,
          color: colors.primaryDark,
          borderRadius: `${radius.sm}px`,
          cursor: "copy",
        }}
      />
    </Tooltip>
  );
}
